import React from 'react';
import { Button } from '@material-ui/core';
import { NONE, emptyText, Q5006, CPF } from '@mummssoftware/utils/constants';
import { CheckOrderButtonsDiv } from '../../../components/layout/WrapperDiv';
import defaults from '../../../translations/en.json';

type CheckOrderButtonsProps = {
  onOrderVerified: (event: any) => void;
  onCancelClick: () => void;
  onModifyClick: () => void;
  orderVerified: boolean;
  orderType: any;
};

const CheckOrderButtons = ({
  onOrderVerified,
  onCancelClick,
  orderVerified,
  onModifyClick,
  orderType,
}: CheckOrderButtonsProps) => (
  <CheckOrderButtonsDiv>
    <Button
      title="OK"
      size="small"
      variant="contained"
      color="primary"
      disabled={!orderVerified}
      onClick={onOrderVerified}
    >
      {defaults.orderVerifiedCheck}
    </Button>
    <Button
      title="Cancel"
      size="small"
      variant="contained"
      color="primary"
      onClick={onCancelClick}
    >
      {defaults.modifyOrder}
    </Button>
    {(orderType === CPF && (
      // todo delete CPF check
      <Button
        title="Cancel"
        size="small"
        variant="contained"
        color="primary"
        onClick={onModifyClick}
      >
        {defaults.modifyDetails}
      </Button>
    )) ||
      null}
  </CheckOrderButtonsDiv>
);
export default CheckOrderButtons;
